(function () {

const $68cce00e20779c30$var$navContainer = document.querySelector(".js-main-navbar");
const $68cce00e20779c30$export$240cd81d1fa164a8 = ()=>{
    $68cce00e20779c30$var$setScrollbarWidth();
    const navigationPopover = document.getElementById("navigation-popover");
    const navigationPopoverTrigger = document.getElementById("navigation-popover-trigger");
    if (!navigationPopover || !navigationPopoverTrigger) return;
    let navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
    if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
    const navItems = $68cce00e20779c30$var$navContainer.querySelectorAll("a[popovertarget]");
    navItems.forEach((item)=>{
        let closeTimeout;
        const popoverTargetId = item.getAttribute("popovertarget");
        const popoverTarget = document.querySelector(`#${popoverTargetId}`);
        if (popoverTarget) {
            item.hidePopover = ()=>{
                popoverTarget.hidePopover();
            };
            item.addEventListener("click", (e)=>{
                if (navigationPopoverActive) {
                    e.preventDefault();
                    popoverTarget.style.setProperty("--anchor-top", `64px`);
                    setTimeout(popoverTarget.togglePopover(), 1);
                }
            });
            item.addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) {
                    clearTimeout(closeTimeout);
                    $68cce00e20779c30$var$setOffset(item, popoverTarget);
                    popoverTarget.showPopover();
                }
            });
            item.addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) clearTimeout(closeTimeout);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            window.addEventListener("resize", ()=>{
                $68cce00e20779c30$var$setScrollbarWidth();
                navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
                if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
                else navigationPopover.removeAttribute("popover");
            });
        }
    });
};
const $68cce00e20779c30$var$setScrollbarWidth = ()=>{
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
};
const $68cce00e20779c30$var$setOffset = (item, popoverTarget)=>{
    const itemPosition = item.getBoundingClientRect();
    const arrowPosition = itemPosition.left + itemPosition.width / 2;
    const { y: navbarBottom } = $68cce00e20779c30$var$navContainer.getBoundingClientRect();
    const topSpacing = navbarBottom + $68cce00e20779c30$var$navContainer.offsetHeight;
    popoverTarget.style.setProperty("--arrow-position-left", `${arrowPosition}px`);
    popoverTarget.style.setProperty("--popover-hover-trigger", popoverTarget.id);
    popoverTarget.style.setProperty("--anchor-top", `${topSpacing}px`);
};


const $7e4debd3f64ec3ac$export$f808344a2ba3e03 = ()=>{
    const filterPopover = document.getElementById("filter-popover");
    const filterPopoverTrigger = document.getElementById("filter-popover-trigger");
    if (!filterPopover || !filterPopoverTrigger) return;
    let filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
    if (filterPopoverActive) filterPopover.setAttribute("popover", "");
    window.addEventListener("resize", ()=>{
        filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
        if (filterPopoverActive) filterPopover.setAttribute("popover", "");
        else filterPopover.removeAttribute("popover");
    });
};


const $31b6f657dffad9ea$export$91db7bf3cf52d2ee = ()=>{
    const providerFilter = document.querySelector('.js-provider-filter');
    const providerList = document.querySelector('.js-provider-list');
    if (!providerFilter || !providerList) return;
    const providerItems = providerList.querySelectorAll('.js-provider-item');
    let delaySearch = null;
    if (!providerFilter || !providerList) return;
    providerFilter.focus();
    function filterProvider(filter) {
        clearTimeout(delaySearch);
        delaySearch = setTimeout(function() {
            processSearch(filter);
        }, 250);
    }
    function processSearch(filter) {
        var providerCount = 0;
        providerItems.forEach((provider)=>{
            var hideThis = provider.innerText.search(new RegExp(filter, 'i')) < 0;
            provider.toggleAttribute("hidden", hideThis);
            providerCount += hideThis ? 0 : 1;
        });
        document.querySelector('.js-number-of-providers').innerText = providerCount;
    }
    providerFilter.addEventListener("input", function() {
        filterProvider(this.value);
    });
};


const $fc3e7aca76592be4$export$6bd9755bd64780dc = ()=>{
    const contextElement = document.getElementById("content-source");
    if (contextElement) $fc3e7aca76592be4$var$wrapTablesInCMSContent(contextElement);
};
const $fc3e7aca76592be4$var$wrapTablesInCMSContent = (contextElement)=>{
    Array.from(contextElement.querySelectorAll("table")).forEach((table)=>{
        table.outerHTML = `<div class="o-scroll-wrapper">${table.outerHTML}</div>`;
    });
};


const $d720ced4833f75d1$var$checkWidget = (e)=>{
    var checkAllFields = e.type == "submit";
    var currentField = e.target;
    if (checkAllFields) document.querySelectorAll(".js-form-error").forEach((errorLabel)=>{
        errorLabel.setAttribute("hidden", "hidden");
    });
    else document.querySelector(currentField.dataset.errorLabel).setAttribute("hidden", "hidden");
    if ((checkAllFields || currentField == hiddenLocationInput) && hiddenLocationInput.value == "") {
        e.preventDefault();
        document.querySelector(hiddenLocationInput.dataset.errorLabel).removeAttribute("hidden");
    }
    if ((checkAllFields || currentField == hiddenUsageInput) && hiddenUsageInput.value == "") {
        e.preventDefault();
        document.querySelector(hiddenUsageInput.dataset.errorLabel).removeAttribute("hidden");
    }
};
class $d720ced4833f75d1$export$76ee4dc31826cca7 {
    constructor(form){
        const hiddenLocationInput1 = document.getElementById("hiddenLocationInput");
        const hiddenUsageInput1 = document.getElementById("hiddenUsageInput");
        form.addEventListener("submit", $d720ced4833f75d1$var$checkWidget);
        hiddenLocationInput1.addEventListener("change", $d720ced4833f75d1$var$checkWidget);
        hiddenUsageInput1.addEventListener("change", $d720ced4833f75d1$var$checkWidget);
    }
}


const $474553cfcd9850af$export$6c6ef03b1e085646 = (widget)=>{
    const inputs = widget.querySelectorAll("input");
    Array.from(inputs).forEach((input)=>{
        input.addEventListener("change", ()=>{
            $474553cfcd9850af$var$checkHeatingSelection(widget);
        });
    });
};
const $474553cfcd9850af$var$setDisabled = (inputs)=>{
    inputs.forEach((input)=>{
        input.setAttribute("disabled", "");
    });
};
const $474553cfcd9850af$var$unsetDisabled = (inputs)=>{
    inputs.forEach((input)=>{
        input.removeAttribute("disabled");
    });
};
const $474553cfcd9850af$var$checkHeatingSelection = (widget)=>{
    const messageElement = widget.querySelector("#heatingWidgetError");
    const heatingTypes = widget.querySelectorAll("input[name='heatingType']");
    const heatingType = widget.querySelector("input[name='heatingType']:checked")?.value;
    const seperateMeters = widget.querySelectorAll("input[name='seperateMeter']");
    const seperateMeter = widget.querySelector("input[name='seperateMeter']:checked")?.value;
    const usageWidget = document.querySelector(".js-usage-widget");
    if (seperateMeter && seperateMeter == "no") {
        usageWidget.setAttribute("data-show-dual-usage", "");
        usageWidget.removeAttribute("data-show-single-dual-toggle");
    } else usageWidget.setAttribute("data-show-single-dual-toggle", "");
    heatingType == "heatpump" ? $474553cfcd9850af$var$setDisabled(seperateMeters) : $474553cfcd9850af$var$unsetDisabled(seperateMeters);
    seperateMeter == "no" ? $474553cfcd9850af$var$setDisabled(heatingTypes) : $474553cfcd9850af$var$unsetDisabled(heatingTypes);
    if (heatingType == "heatpump" || seperateMeter == "no") messageElement.removeAttribute("hidden");
    else messageElement.setAttribute("hidden", "");
};


/**
 * Basis tool voor het afhandelen van async communicatie. Hier is eventueel nog een standaard error afhandeling tussen te hangen.
 */ /**
 * Fetches data from the given URL using a GET request.
 *
 * @async
 * @function getUrl
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$getUrl = async (url)=>{
    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        }
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = await response.json();
    return {
        status: status,
        data: data
    };
};
/**
 * Sends data to the given URL using a POST request.
 *
 * @async
 * @function postUrl
 * @param {string} url - The URL to send data to.
 * @param {Object} postData - The data to send in the body of the POST request.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$postUrl = async (url, postData)=>{
    const options = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache"
        },
        body: JSON.stringify(postData)
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = null;
    try {
        data = await response?.json();
    } catch (error) {}
    return {
        status: status,
        data: data
    };
};
const $80b8792c09f43040$export$f8a0a232efd61230 = ()=>{
    return {
        getUrl: $80b8792c09f43040$var$getUrl,
        postUrl: $80b8792c09f43040$var$postUrl
    };
};


const $6be05c95c886a85c$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $6be05c95c886a85c$export$9f208cdfec86ac41 = ()=>{
    const ortusApi = window.ortus.api;
    /**
   * @method getForm
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the form.
   */ const getForm = async (tariffId)=>{
        const url = `${ortusApi}signupform?tariffId=${tariffId}`;
        try {
            const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
            return {
                status: status,
                data: data
            };
        } catch (e) {
            console.log(e);
        }
    };
    /**
   * @method getTariffData
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @param {string} energyType - The type of energy.
   * @param {string} query - The query string.
   * @returns {Promise<Object>} The status and data of the tariff.
   */ const getTariffData = async (tariffId, energyType, query)=>{
        const detailUrl = `https://www.verivox.de/servicehook/offers/${energyType}/info/${query}/${tariffId}?partnerId=2624`;
        const proxyUrl = `${ortusApi}package/detail`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(proxyUrl, {
            packageDetailsUri: detailUrl
        });
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getStreetsForPostCode
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} city - The city name.
   * @returns {Promise<Array<string>>} A list of street names.
   */ const getStreetsForPostCode = async (postCode, city)=>{
        city = decodeURIComponent(city).split(" / ")[0].replace(/\//g, "-").trim();
        let url = `${ortusApi}signupform/streets?postCode=${postCode}&cityName=${city}`;
        const data = await fetch(url).then((response)=>response.json());
        const streets = data.map((s)=>s.Name);
        return streets;
    };
    /**
   * @method getCityDistricts
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} [energyType='electricity'] - The type of energy.
   * @returns {Promise<Object>} The status and data of the city parts.
   */ // TODO: use alternative endpoint for getting cities without specifying a producttype
    const getCityDistricts = async (postCode, energyType = "electricity")=>{
        const url = `${ortusApi}location/${postCode}/${energyType}`;
        const { status: status, data: data } = await (0, $80b8792c09f43040$export$f8a0a232efd61230)().getUrl(url);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getIsValidIBAN
   * @async
   * @param {string} iban - The IBAN to validate.
   * @returns {Promise<Object>} The status and data of the IBAN validation.
   */ const getIsValidIBAN = async (iban)=>{
        const url = `${ortusApi}signupform/iban?iBan=${iban}`;
        // Test for success: DE91500105174885792721
        // Test to fail: GT47195126765214373483528657
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmark
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Object>} The status and data of the benchmark.
   */ const getBenchmark = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const url = `${ortusApi}benchmarks?product=${product}&profile=${profile}&postCode=${postCode}&locationId=${locationId}&totalUsage=${totalUsage}&heatingPower=${heatingPower}`;
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmarkSuppliers
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Array<Object>>} A list of suppliers.
   */ const getBenchmarkSuppliers = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const { data: data, status: status } = await getBenchmark(product, profile, postCode, locationId, totalUsage, heatingPower);
        if (status !== 200) throw new Error("Could not fetch suppliers");
        const providers = data.providers.map((p)=>{
            return {
                name: p.content.text,
                label: p.content.text,
                id: p.id,
                tariffs: p.products
            };
        });
        return providers;
    };
    /**
   * @method getSuppliers
   * @async
   * @param {string} productType - electricity or gas
   * @returns {Promise<Array<Object>>}  The status and data of the list of suppliers
   */ const getSuppliers = async (productType = "Electricity")=>{
        const normalizedProductType = String(productType || "electricity").toLowerCase();
        const providerUrl = `${ortusApi}getAllProviders/${normalizedProductType}`;
        const mapProviders = (providerData)=>{
            if (!Array.isArray(providerData)) return [];
            return providerData.map((p, index)=>{
                const name = p?.value ?? p?.name ?? p?.providerName ?? p?.label ?? p;
                const id = p?.id ?? p?.providerId ?? String(index);
                const aliases = Array.isArray(p?.aliases) ? p.aliases : [];
                return {
                    name: name,
                    label: name,
                    id: id,
                    aliases: aliases
                };
            });
        };
        try {
            const localResult = await $6be05c95c886a85c$var$asyncHelper.getUrl(localUrl);
            if (localResult?.status === 200) return mapProviders(localResult.data);
        } catch (error) {}
        const apiResult = await $6be05c95c886a85c$var$asyncHelper.getUrl(providerUrl);
        return mapProviders(apiResult.data);
    };
    /**
   * @method storeData
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the stored data.
   */ const storeData = async (postData, productType, tariffId)=>{
        postData.connectionData.currentProvider = postData.connectionData.currentProvider?.name ?? postData.connectionData.currentProvider;
        const url = `${ortusApi}signuprequest/${productType}/${tariffId}`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method previewPdf
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the PDF preview.
   */ const previewPdf = async (postData, productType, tariffId)=>{
        const url = `${ortusApi}contractPreview/${tariffId}`;
        const { data: data, status: status } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    return {
        getCityDistricts: getCityDistricts,
        getBenchmarkSuppliers: getBenchmarkSuppliers,
        getSuppliers: getSuppliers,
        getStreetsForPostCode: getStreetsForPostCode,
        getBenchmark: getBenchmark,
        getForm: getForm,
        getTariffData: getTariffData,
        getIsValidIBAN: getIsValidIBAN,
        storeData: storeData,
        previewPdf: previewPdf
    };
};


// Shared state for the postal code change flag
let $5844f3601c6aa971$var$isPostalCodeChanged = false;
const $5844f3601c6aa971$export$fd899442b799a682 = (value)=>{
    $5844f3601c6aa971$var$isPostalCodeChanged = value;
};
const $5844f3601c6aa971$export$60d251412f427c30 = ()=>{
    return $5844f3601c6aa971$var$isPostalCodeChanged;
};



const $87dd73750fb93037$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $87dd73750fb93037$export$72faef17ae298338 = async (config)=>{
    const { data: initialData } = await $87dd73750fb93037$var$asyncHelper.getUrl(config.getApiUrl());
    let { filters: filters, results: results } = $87dd73750fb93037$var$getRelevantSearchData(initialData);
    return {
        filters: filters,
        results: results
    };
};
const $87dd73750fb93037$export$cfcc0908d6dfb8a6 = async (config, userFormData = {})=>{
    const productType = window.ortus.productType ?? "electricity";
    const baseFormData = {
        productType: productType,
        resultsOnly: false,
        pageSize: 10,
        page: 1,
        benchmark: 1
    };
    const formData = {
        ...baseFormData,
        ...userFormData
    };
    const { data: searchData } = await $87dd73750fb93037$var$asyncHelper.postUrl(`${config.getApiUrl()}calculator/energy`, formData);
    return $87dd73750fb93037$var$getRelevantSearchData(searchData);
};
const $87dd73750fb93037$var$getRelevantSearchData = (apiData)=>{
    const filters = apiData?.filters;
    const results = apiData?.offers;
    const benchmarkTariff = apiData?.benchmarkTariff;
    return {
        filters: filters,
        results: results,
        benchmarkTariff: benchmarkTariff
    };
};
const $87dd73750fb93037$export$cfce4cb39c87df1c = async (packageUrl)=>{
    const packageDetails = await $87dd73750fb93037$var$asyncHelper.getUrl(packageUrl);
    return packageDetails;
};


const $e9824b957d40652f$export$adf416f00cca6418 = (module, apiUrl = null)=>{
    const getApiUrl = ()=>{
        if (!apiUrl) throw new Error('No API URL provided');
        return apiUrl;
    };
    const getLsKey = ()=>{
        return `${module}-filters`;
    };
    return {
        getLsKey: getLsKey,
        getApiUrl: getApiUrl
    };
};



let $3fd9eea943d721cb$var$filterData = null;
let $3fd9eea943d721cb$var$searchResults = null;
let $3fd9eea943d721cb$var$config;
let $3fd9eea943d721cb$var$filterForm;
let $3fd9eea943d721cb$var$updateFunction;
let $3fd9eea943d721cb$var$storedPagingButton = "";
let $3fd9eea943d721cb$var$settings = {
    filterForm: null
};
const $3fd9eea943d721cb$export$be042cd8f6323421 = async ({ apiUrl: apiUrl, filterForm: filterForm, pagingButton: pagingButton })=>{
    $3fd9eea943d721cb$var$config = (0, $e9824b957d40652f$export$adf416f00cca6418)("wj", apiUrl);
    $3fd9eea943d721cb$var$settings.filterForm = filterForm;
    $3fd9eea943d721cb$var$storedPagingButton = pagingButton;
    let formData = $3fd9eea943d721cb$var$getFilterFormData();
    let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, formData);
    const pageInput = filterForm.querySelector('input[name="page"]');
    setTimeout(()=>{
        pageInput.value = 1;
        $3fd9eea943d721cb$var$setFormInputWatcher(pageInput);
    }, 200);
    pagingButton.removeAttribute("hidden");
    if (!pagingButton.dataset.vxPagingBound) {
        pagingButton.addEventListener("click", $3fd9eea943d721cb$var$handlePagingButtonClick);
        pagingButton.dataset.vxPagingBound = "true";
    }
    return {
        comparisonData: {
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        },
        tooling: {
            onResultsUpdated: $3fd9eea943d721cb$var$onResultsUpdated
        }
    };
};
const $3fd9eea943d721cb$var$handlePagingButtonClick = async ()=>{
    const pageInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector('input[name="page"]');
    const currentPage = parseInt(pageInput.value) || 1;
    pageInput.value = currentPage + 1;
    $3fd9eea943d721cb$var$onFiltersChanged({
        skipTimeout: true
    });
};
const $3fd9eea943d721cb$var$setFormInputWatcher = (pageInput)=>{
    const inputs = $3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select");
    Array.from(inputs).filter((i)=>{
        return i.dataset.skipSubmit !== "true";
    }).filter((i)=>{
        return i.dataset.ignore !== "true";
    }).forEach((input)=>{
        if (input.dataset.vxBound === "true") return;
        input.addEventListener("change", ()=>{
            pageInput.value = 1;
            $3fd9eea943d721cb$var$onFiltersChanged({
                skipTimeout: false
            });
        });
        input.dataset.vxBound = "true";
    });
    const priceDisplayInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector("[name=priceDisplay]");
    $3fd9eea943d721cb$var$setPriceDisplayChangeHandler(priceDisplayInput);
};
const $3fd9eea943d721cb$var$setPriceDisplayChangeHandler = (priceDisplayInput)=>{
    if (!priceDisplayInput || priceDisplayInput.dataset.vxPriceDisplayBound === "true") return;
    priceDisplayInput.addEventListener("change", ()=>{
        const selectedPriceDisplay = priceDisplayInput.value;
        const wjPackageElements = document.querySelectorAll("wj-package");
        Array.from(wjPackageElements).forEach((element)=>{
            element.dataset.priceDisplay = selectedPriceDisplay;
        });
    });
    priceDisplayInput.dataset.vxPriceDisplayBound = "true";
};
const $3fd9eea943d721cb$var$syncComparisonUrlWithFormData = ()=>{
    if (!window.history?.replaceState) return;
    const formData = $3fd9eea943d721cb$var$getFilterFormData();
    const selectedAddress = document.querySelector("#selectedAddress")?.value || "";
    const hiddenLocation = document.querySelector("#hiddenLocationInput")?.value || "";
    const postalCode = document.querySelector("#postalCode")?.value || "";
    const mappedParams = {
        postCode: postalCode,
        city: selectedAddress ? selectedAddress.replace("/", "-") : "",
        location: hiddenLocation,
        usage: formData.usage,
        highUsage: formData.highUsage,
        lowUsage: formData.lowUsage,
        heatingType: formData.heatingType,
        meterType: formData.meterType,
        page: formData.page,
        pageSize: formData.pageSize
    };
    const nextUrl = new URL(window.location.href);
    Object.entries(mappedParams).forEach(([key, value])=>{
        if (value === undefined || value === null || value === "") {
            nextUrl.searchParams.delete(key);
            return;
        }
        nextUrl.searchParams.set(key, String(value));
    });
    const queryString = nextUrl.searchParams.toString();
    const stateUrl = `${nextUrl.pathname}${queryString ? `?${queryString}` : ""}${nextUrl.hash}`;
    window.history.replaceState({
        ...window.history.state,
        comparisonForm: mappedParams
    }, "", stateUrl);
};
const $3fd9eea943d721cb$var$getFilterFormData = ()=>{
    const inputsArr = Array.from($3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select"));
    const formProps = $3fd9eea943d721cb$var$getUniqueFormProps(inputsArr);
    const filterFormData = {};
    inputsArr.filter((i)=>!i.dataset.formProp).forEach((input)=>{
        let { value: value, checked: checked, name: name, type: type } = input;
        if (type == "radio") {
            if (checked) {
                if (value === "true") value = true;
                else if (value === "false") value = false;
                filterFormData[name] = value;
            }
        } else if (type == "checkbox") filterFormData[name] = checked;
        else filterFormData[name] = value;
    });
    // Reset benchmark to -1 ONLY if postal code has changed
    if ((0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        filterFormData.benchmark = "-1"; // Reset benchmark
        filterFormData[""] = false;
    }
    formProps.forEach((formProp)=>{
        let myValue = [];
        myValue = inputsArr.filter((i)=>i.dataset.formProp === formProp && i.checked).map((input)=>{
            let { value: value } = input;
            return value;
        });
        filterFormData[formProp] = myValue.join(",");
    });
    return filterFormData;
};
const $3fd9eea943d721cb$var$getUniqueFormProps = (inputsArr)=>{
    // TODO  check if needed
    const formProps = [];
    inputsArr.map((i)=>{
        const formProp = i.dataset.formProp;
        if (formProp && formProps.indexOf(formProp) === -1) formProps.push(formProp);
    });
    return formProps;
};
let $3fd9eea943d721cb$var$searchTimeout = 1;
const $3fd9eea943d721cb$var$resultsWrapper = document.getElementById("packageResults");
const $3fd9eea943d721cb$var$savingsWrapper = document.querySelector(".js-saving-banner");
const $3fd9eea943d721cb$var$onFiltersChanged = async ({ skipTimeout: skipTimeout = false })=>{
    if ($3fd9eea943d721cb$var$searchTimeout) {
        clearTimeout($3fd9eea943d721cb$var$searchTimeout);
        $3fd9eea943d721cb$var$searchTimeout = null;
    }
    $3fd9eea943d721cb$var$resultsWrapper.style.filter = "blur(5px)";
    $3fd9eea943d721cb$var$savingsWrapper.style.filter = "blur(5px)";
    const timeoutDuration = skipTimeout ? 0 : 800;
    $3fd9eea943d721cb$var$searchTimeout = setTimeout(async ()=>{
        $3fd9eea943d721cb$var$storedPagingButton.setAttribute("disabled", "disabled");
        let formValidation = $3fd9eea943d721cb$var$formIsValid($3fd9eea943d721cb$var$settings.filterForm);
        if (formValidation.isValid) {
            $3fd9eea943d721cb$var$syncComparisonUrlWithFormData();
            await $3fd9eea943d721cb$var$executeSearch();
        } else console.log(formValidation.errors);
        $3fd9eea943d721cb$var$storedPagingButton.removeAttribute("disabled");
        $3fd9eea943d721cb$var$resultsWrapper.style.filter = "";
        $3fd9eea943d721cb$var$savingsWrapper.style.filter = "";
    }, timeoutDuration);
};
const $3fd9eea943d721cb$var$formIsValid = (form)=>{
    let isValid = true;
    let errors = [];
    const hiddenLocationInput = form.querySelector("#hiddenLocationInput").value;
    if (hiddenLocationInput == "") {
        errors.push("Kein addresse gefunden. Bitte versuchen Sie es erneut.");
        isValid = false;
    }
    return {
        isValid: isValid,
        errors: errors
    };
};
const $3fd9eea943d721cb$var$executeSearch = async (appendingData)=>{
    // only execute the search if the postal code has not changed
    if (!(0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        let searchData = $3fd9eea943d721cb$var$getFilterFormData();
        searchData.resultsOnly = true;
        let formData = {
            ...searchData,
            ...appendingData
        };
        let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, searchData);
        $3fd9eea943d721cb$var$updateFunction({
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        });
        (0, $5844f3601c6aa971$export$fd899442b799a682)(false); // Reset the flag
    }
};
const $3fd9eea943d721cb$var$onResultsUpdated = (updateData)=>{
    $3fd9eea943d721cb$var$updateFunction = updateData;
};


const $6a437dcba1085657$var$renderPackages = (searchResultsData)=>{
    const priceDisplay = searchResultsData.formData.priceDisplay;
    searchResultsData.data.forEach((element)=>{
        let myElement = document.createElement('wj-package');
        myElement.dataset.packageElement = JSON.stringify(element);
        myElement.dataset.priceDisplay = priceDisplay;
        searchResultsData.target.appendChild(myElement);
    });
};
var $6a437dcba1085657$export$2e2bcd8739ae039 = $6a437dcba1085657$var$renderPackages;



const $9ad4a19502edd57e$export$394e73e0cf9f022a = async ()=>{
    const ortusApi = window.ortus.api;
    const wrapper = document.querySelector(".js-comparison-wrapper");
    const filterForm1 = document.getElementById("filterForm");
    const pagingButton = document.getElementById("pagingButton");
    if (!filterForm1) {
        console.info("No form supplied. Cancelling initialisation");
        return;
    }
    const { postCode: postCode, city: city, location: location1 } = $9ad4a19502edd57e$var$getUrlParameters();
    if (filterForm1.querySelector("#hiddenLocationInput").value === "") filterForm1.querySelector("#hiddenLocationInput").value = location1;
    const searchTool = await (0, $3fd9eea943d721cb$export$be042cd8f6323421)({
        apiUrl: ortusApi,
        filterForm: filterForm1,
        pagingButton: pagingButton
    });
    searchTool.tooling.onResultsUpdated($9ad4a19502edd57e$var$handleNewData);
    $9ad4a19502edd57e$var$setSupplierAndTariffSelects(searchTool.comparisonData.benchmarkTariff);
    setTimeout(()=>{
        $9ad4a19502edd57e$var$handleNewData(searchTool.comparisonData);
        wrapper.querySelector("bc-loading-icon")?.remove();
    }, 1);
};
const $9ad4a19502edd57e$var$setSupplierAndTariffSelects = async (benchmarkTariff)=>{
    let productType = filterForm.querySelector("#hiddenProductType").value;
    let locationId = filterForm.querySelector("#hiddenLocationInput").value;
    let postCode = filterForm.querySelector("#postalCode").value;
    let usage = filterForm.querySelector("#hiddenUsageInput").value;
    const suppliers = await (0, $6be05c95c886a85c$export$9f208cdfec86ac41)().getBenchmarkSuppliers(productType, undefined, postCode, locationId, usage);
    let benchmarkSupplierId = null;
    let benchmarkTariffId = null;
    if (benchmarkTariff) {
        benchmarkSupplierId = benchmarkTariff.provider?.id;
        benchmarkTariffId = benchmarkTariff.id;
    }
    let supplierSelect = document.getElementById("previousSupplier");
    let tariffSelect = document.getElementById("previousTariff");
    supplierSelect.innerHTML = "";
    supplierSelect.innerHTML += `<option value="">Bitte wahle dein Anbieter aus</option>`;
    suppliers.forEach((supplier)=>{
        let isSelected = supplier.id == benchmarkSupplierId ? "selected" : "";
        supplierSelect.innerHTML += `<option ${isSelected} value="${supplier.id}" data-tariffs='${JSON.stringify(supplier.tariffs)}' value="${supplier.name}">${supplier.name}</option>`;
    });
    supplierSelect.addEventListener("change", (e)=>{
        let selectedSupplierId = e.target.value;
        if (selectedSupplierId) {
            let selectedSupplier = suppliers.find((s)=>s.id === selectedSupplierId);
            tariffSelect.innerHTML = "";
            tariffSelect.innerHTML += `<option value="-1">Bitte wahle dein Tarif aus</option>`;
            selectedSupplier.tariffs.forEach((tariff)=>{
                let isSelected = tariff.id == benchmarkTariffId ? "selected" : "";
                tariffSelect.innerHTML += `<option ${isSelected} value="${tariff.id}">${tariff.content.text}</option>`;
            });
        }
    });
    if (benchmarkSupplierId) supplierSelect.dispatchEvent(new Event("change", {
        bubbles: true
    }));
};
const $9ad4a19502edd57e$var$getUrlParameters = ()=>{
    const params = Object.fromEntries(new URLSearchParams(location.search));
    return params;
};
const $9ad4a19502edd57e$var$euroDisplay = (amount)=>{
    if (isNaN(amount) && typeof amount === "string" && amount.indexOf(",") > -1) amount = amount.replace(/\,/g, ".");
    return parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;";
};
const $9ad4a19502edd57e$var$handleNewData = (searchData)=>{
    let results, benchmarkTariff, formData;
    if (searchData) ({ results: results, benchmarkTariff: benchmarkTariff, formData: formData } = searchData);
    if (!results) return;
    const resultsContainer = document.getElementById("packageResults");
    if (benchmarkTariff) {
        const savingAmount = results[0]?.cost.savings.amount;
        const savingAmountRounded = Math.round(savingAmount);
        if (savingAmount > 20) {
            document.querySelector(".js-saving-banner__saving-amount").innerHTML = savingAmountRounded.toString() + "&nbsp;&euro;";
            document.querySelector(".js-saving-banner__benchmark-amount").innerHTML = $9ad4a19502edd57e$var$euroDisplay(benchmarkTariff.totalCostInEuro);
            document.querySelector(".js-saving-banner__benchmark-provider").innerHTML = benchmarkTariff.providerName.content.text;
            document.querySelector(".js-saving-banner__benchmark-location").innerHTML = benchmarkTariff.tariff?.content.text;
            document.querySelector(".js-saving-banner__saving-header").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__saving-subtext").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__low-saving-message").setAttribute("hidden", true);
        } else {
            document.querySelector(".js-saving-banner__saving-header").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__saving-subtext").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__low-saving-message").removeAttribute("hidden");
        }
        document.querySelector(".js-saving-banner").removeAttribute("hidden");
        if (!benchmarkTariff.providerName.content.text) {
            document.querySelector(".js-meta-data--default-supplier").setAttribute("hidden", true);
            document.querySelector(".js-meta-data--heatingelectricity-default-provider").setAttribute("hidden", true);
        } else document.querySelector(".js-meta-data--default-supplier").removeAttribute("hidden");
        document.querySelector(".js-meta-data--supplier").innerHTML = benchmarkTariff.providerName.content.text;
        document.querySelector(".js-meta-data--tariff").innerHTML = benchmarkTariff.tariffName.content.text;
    }
    const currentCity = document.querySelector("#selectedAddress")?.value || window.ortus.preselectedValues?.city;
    if (currentCity) document.querySelector(".js-meta-data--city").innerHTML = currentCity;
    if (window.ortus.preselectedValues?.energyArea) {
        let energyArea = window.ortus.preselectedValues.energyArea;
        if (energyArea === "heating") ;
        else if (energyArea === "green") document.querySelector('input[name="isGreenElectricity"][value="true"]').checked = true;
    }
    const page = parseInt(formData.page);
    const pageSize = parseInt(formData.pageSize);
    if (page == 1) resultsContainer.innerHTML = "";
    let searchResultsData = {
        data: results,
        target: resultsContainer,
        formData: formData
    };
    Array.from(document.querySelectorAll("bc-loading-icon"))?.forEach((icon)=>icon.remove());
    (0, $6a437dcba1085657$export$2e2bcd8739ae039)(searchResultsData);
};


let $2c95b4ed0ac49682$var$isPostalCodeChanged = false; // Flag to track postal code changes
/*
  * addressSolver
  Vanilla JS implementatie van de address solver met een reguliere template in de CSHTML file in het webproject.
*/ class $2c95b4ed0ac49682$export$33f74ecdf75d2956 {
    constructor(wrapper){
        this.postCodeInput = document.getElementById("postalCode");
        this.selectedAddress = document.getElementById("selectedAddress");
        this.lastFetchedPostCode = null;
        this.isInstantFilterBody = Boolean(this.postCodeInput?.closest(".c-filter-section__body--instant"));
        this.isHomeInputWidget = Boolean(this.postCodeInput?.closest(".js-input-widget"));
        //When using Enter key, move the focus to the address input so it does not trigger the submit
        this.postCodeInput.onkeydown = (e)=>{
            if (e.key === "Enter") this.selectedAddressRef.focus();
        };
        const handlePostCodeValueChange = ()=>{
            const postCodeValue = this.postCodeInput.value?.trim() || "";
            const hasValidLength = postCodeValue.length >= 5 && postCodeValue.length <= 6;
            if (!hasValidLength) {
                this.lastFetchedPostCode = null;
                this._fetchAddress();
                return;
            }
            if (this.lastFetchedPostCode === postCodeValue) return;
            this.lastFetchedPostCode = postCodeValue;
            (0, $5844f3601c6aa971$export$fd899442b799a682)(true);
            this._fetchAddress();
        };
        if (this.isInstantFilterBody || this.isHomeInputWidget) this.postCodeInput.addEventListener("input", handlePostCodeValueChange);
        this.postCodeInput.addEventListener("change", handlePostCodeValueChange);
        this.selectAddressWrapper = document.getElementById("selectAddressWrapper");
        this.errorText = document.getElementById("errorText");
        this.selectedAddress = null;
        this.isLoading = false;
        this.loadingIcon = document.getElementById("address-solver-loader");
        this.foundAddresses = [];
        this.selectedAddressRef = document.querySelector("#selectedAddress");
        this.selectedAddressRef.addEventListener("change", ()=>{
            this._selectAddress();
        });
        this.inputRef = document.querySelector("#inputRef");
        this.productType = document.getElementById("hiddenProductType");
        this.postCode = wrapper.dataset.preselectedPostcode;
        this.location = wrapper.dataset.preselectedLocation;
        this.city = wrapper.dataset.preselectedCity;
        if (this.postCode) {
            this.postCodeInput.value = this.postCode;
            this._setPreselectedCity();
            return;
        }
        if (this.preselectedCity) {
            this.selectedAddress = decodeURIComponent(this.city);
            this._setPreselectedCity();
            return;
        }
        if (window.ortus.preselectedValues && window.ortus.preselectedValues.city) {
            this.city = window.ortus.preselectedValues.city;
            this._setPreselectedCity();
            return;
        }
        this._fetchAddress();
    }
    async _setPreselectedCity() {
        await this._fetchAddress();
        let options = this.selectedAddressRef.options;
        Array.from(options).forEach((option)=>{
            if (option.value == this.city) option.setAttribute("selected", "selected");
        });
    }
    _setLoadingState() {
        this.loadingIcon.hidden = !this.isLoading;
        if (this.isLoading) this.selectAddressWrapper.setAttribute("hidden", "hidden");
        else this.selectAddressWrapper.removeAttribute("hidden");
    }
    _selectAddress() {
        let select = this.selectedAddressRef;
        let selectedOption = select.options[select.selectedIndex];
        let selectedAddress = selectedOption.dataset.address;
        document.getElementById("hiddenLocationInput").value = "";
        if (selectedAddress) {
            let address = JSON.parse(selectedAddress);
            this.selectedAddress = address.fullName;
            document.getElementById("hiddenLocationInput").value = address.id ?? -1;
            document.getElementById("hiddenLocationInput").dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this.errorText.innerHTML = "";
            this.errorText.hidden = true;
            // reset Anbieter and Tarif, otherwise the benchmark tariff might result in issues due to not being available at the chosen location.
            let previousSupplierElement = document.getElementById("previousSupplier");
            if (previousSupplierElement) previousSupplierElement.value = "";
            let previousTariffElement = document.getElementById("previousTariff");
            if (previousTariffElement) previousTariffElement.value = "-1";
            (0, $9ad4a19502edd57e$export$394e73e0cf9f022a)();
        }
    }
    _clearAddress() {
        this.selectedAddress = null;
        document.getElementById("hiddenLocationInput").value = "";
    }
    async _fetchAddress() {
        const userPostalCode = this.postCodeInput.value;
        while(this.selectedAddressRef.children.length > 1)this.selectedAddressRef.removeChild(this.selectedAddressRef.lastChild);
        if (userPostalCode.length < 5 || userPostalCode.length > 6) {
            document.getElementById("hiddenLocationInput").value = "";
            this.selectedAddressRef.setAttribute("disabled", "disabled");
            return false;
        }
        this.selectedAddressRef.removeAttribute("disabled");
        this.foundAddresses = [];
        this.isLoading = true;
        this._setLoadingState();
        this.loadingIcon.hidden = false;
        this.errorText.innerHTML = "";
        this.errorText.hidden = true;
        let { data: data, status: status } = await (0, $6be05c95c886a85c$export$9f208cdfec86ac41)().getCityDistricts(userPostalCode, this.productType.value);
        if (status == 200) {
            if (data.locationList?.length > 0) this.foundAddresses = data.locationList;
            else if (data.mainName != null) this.foundAddresses.push({
                fullName: data.mainName,
                id: data.mainId
            });
            let selected = false;
            this.foundAddresses.forEach((address)=>{
                let option = document.createElement("option");
                option.value = address.fullName;
                option.dataset.address = JSON.stringify(address);
                option.innerText = address.fullName;
                if (address.id && address.id === window.ortus.preselectedValues?.location) {
                    option.setAttribute("selected", "selected");
                    selected = true;
                } else option.removeAttribute("selected");
                this.selectedAddressRef.appendChild(option);
            });
            if (!selected) {
                this.selectedAddressRef.options[1].setAttribute("selected", "selected");
                this._selectAddress();
            }
        } else {
            this.errorText.innerHTML = "Es ist ein Fehler aufgetreten. Kontrolieren Sie Ihre Postleitzahl";
            this.errorText.hidden = false;
            var filerSectionYourData = document.getElementById("filter-section__your-data");
            filerSectionYourData != null && (filerSectionYourData.checked = true);
        }
        this.isLoading = false;
        this._setLoadingState();
    }
}


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2ebca2d23ae8704c$var$t = globalThis, $2ebca2d23ae8704c$export$b4d10f6001c083c2 = $2ebca2d23ae8704c$var$t.ShadowRoot && (void 0 === $2ebca2d23ae8704c$var$t.ShadyCSS || $2ebca2d23ae8704c$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $2ebca2d23ae8704c$var$s = Symbol(), $2ebca2d23ae8704c$var$o = new WeakMap;
class $2ebca2d23ae8704c$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $2ebca2d23ae8704c$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($2ebca2d23ae8704c$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $2ebca2d23ae8704c$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $2ebca2d23ae8704c$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $2ebca2d23ae8704c$export$8d80f9cac07cdb3 = (t)=>new $2ebca2d23ae8704c$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $2ebca2d23ae8704c$var$s), $2ebca2d23ae8704c$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $2ebca2d23ae8704c$export$505d1e8739bad805(o, t, $2ebca2d23ae8704c$var$s);
}, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($2ebca2d23ae8704c$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $2ebca2d23ae8704c$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $2ebca2d23ae8704c$export$ee69dfd951e24778 = $2ebca2d23ae8704c$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $2ebca2d23ae8704c$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $85ef972dd7b092e7$var$i, defineProperty: $85ef972dd7b092e7$var$e, getOwnPropertyDescriptor: $85ef972dd7b092e7$var$h, getOwnPropertyNames: $85ef972dd7b092e7$var$r, getOwnPropertySymbols: $85ef972dd7b092e7$var$o, getPrototypeOf: $85ef972dd7b092e7$var$n } = Object, $85ef972dd7b092e7$var$a = globalThis, $85ef972dd7b092e7$var$c = $85ef972dd7b092e7$var$a.trustedTypes, $85ef972dd7b092e7$var$l = $85ef972dd7b092e7$var$c ? $85ef972dd7b092e7$var$c.emptyScript : "", $85ef972dd7b092e7$var$p = $85ef972dd7b092e7$var$a.reactiveElementPolyfillSupport, $85ef972dd7b092e7$var$d = (t, s)=>t, $85ef972dd7b092e7$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $85ef972dd7b092e7$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $85ef972dd7b092e7$export$53a6892c50694894 = (t, s)=>!$85ef972dd7b092e7$var$i(t, s), $85ef972dd7b092e7$var$b = {
    attribute: !0,
    type: String,
    converter: $85ef972dd7b092e7$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $85ef972dd7b092e7$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $85ef972dd7b092e7$var$a.litPropertyMetadata ??= new WeakMap;
class $85ef972dd7b092e7$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $85ef972dd7b092e7$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $85ef972dd7b092e7$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $85ef972dd7b092e7$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $85ef972dd7b092e7$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("elementProperties"))) return;
        const t = $85ef972dd7b092e7$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($85ef972dd7b092e7$var$d("properties"))) {
            const t = this.properties, s = [
                ...$85ef972dd7b092e7$var$r(t),
                ...$85ef972dd7b092e7$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $85ef972dd7b092e7$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $85ef972dd7b092e7$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $85ef972dd7b092e7$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$85ef972dd7b092e7$export$c7c07a37856565d.elementStyles = [], $85ef972dd7b092e7$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("elementProperties")] = new Map, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("finalized")] = new Map, $85ef972dd7b092e7$var$p?.({
    ReactiveElement: $85ef972dd7b092e7$export$c7c07a37856565d
}), ($85ef972dd7b092e7$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bd6886d5707a45a8$var$t = globalThis, $bd6886d5707a45a8$var$i = (t)=>t, $bd6886d5707a45a8$var$s = $bd6886d5707a45a8$var$t.trustedTypes, $bd6886d5707a45a8$var$e = $bd6886d5707a45a8$var$s ? $bd6886d5707a45a8$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $bd6886d5707a45a8$var$h = "$lit$", $bd6886d5707a45a8$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $bd6886d5707a45a8$var$n = "?" + $bd6886d5707a45a8$var$o, $bd6886d5707a45a8$var$r = `<${$bd6886d5707a45a8$var$n}>`, $bd6886d5707a45a8$var$l = document, $bd6886d5707a45a8$var$c = ()=>$bd6886d5707a45a8$var$l.createComment(""), $bd6886d5707a45a8$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $bd6886d5707a45a8$var$u = Array.isArray, $bd6886d5707a45a8$var$d = (t)=>$bd6886d5707a45a8$var$u(t) || "function" == typeof t?.[Symbol.iterator], $bd6886d5707a45a8$var$f = "[ \t\n\f\r]", $bd6886d5707a45a8$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $bd6886d5707a45a8$var$_ = /-->/g, $bd6886d5707a45a8$var$m = />/g, $bd6886d5707a45a8$var$p = RegExp(`>|${$bd6886d5707a45a8$var$f}(?:([^\\s"'>=/]+)(${$bd6886d5707a45a8$var$f}*=${$bd6886d5707a45a8$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $bd6886d5707a45a8$var$g = /'/g, $bd6886d5707a45a8$var$$ = /"/g, $bd6886d5707a45a8$var$y = /^(?:script|style|textarea|title)$/i, $bd6886d5707a45a8$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $bd6886d5707a45a8$export$c0bb0b647f701bb5 = $bd6886d5707a45a8$var$x(1), $bd6886d5707a45a8$export$7ed1367e7fa1ad68 = $bd6886d5707a45a8$var$x(2), $bd6886d5707a45a8$export$47d5b44d225be5b4 = $bd6886d5707a45a8$var$x(3), $bd6886d5707a45a8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $bd6886d5707a45a8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $bd6886d5707a45a8$var$C = new WeakMap, $bd6886d5707a45a8$var$P = $bd6886d5707a45a8$var$l.createTreeWalker($bd6886d5707a45a8$var$l, 129);
function $bd6886d5707a45a8$var$V(t, i) {
    if (!$bd6886d5707a45a8$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $bd6886d5707a45a8$var$e ? $bd6886d5707a45a8$var$e.createHTML(i) : i;
}
const $bd6886d5707a45a8$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $bd6886d5707a45a8$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $bd6886d5707a45a8$var$v ? "!--" === u[1] ? c = $bd6886d5707a45a8$var$_ : void 0 !== u[1] ? c = $bd6886d5707a45a8$var$m : void 0 !== u[2] ? ($bd6886d5707a45a8$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $bd6886d5707a45a8$var$p) : void 0 !== u[3] && (c = $bd6886d5707a45a8$var$p) : c === $bd6886d5707a45a8$var$p ? ">" === u[0] ? (c = n ?? $bd6886d5707a45a8$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $bd6886d5707a45a8$var$p : '"' === u[3] ? $bd6886d5707a45a8$var$$ : $bd6886d5707a45a8$var$g) : c === $bd6886d5707a45a8$var$$ || c === $bd6886d5707a45a8$var$g ? c = $bd6886d5707a45a8$var$p : c === $bd6886d5707a45a8$var$_ || c === $bd6886d5707a45a8$var$m ? c = $bd6886d5707a45a8$var$v : (c = $bd6886d5707a45a8$var$p, n = void 0);
        const x = c === $bd6886d5707a45a8$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $bd6886d5707a45a8$var$v ? s + $bd6886d5707a45a8$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $bd6886d5707a45a8$var$h + s.slice(d) + $bd6886d5707a45a8$var$o + x) : s + $bd6886d5707a45a8$var$o + (-2 === d ? i : x);
    }
    return [
        $bd6886d5707a45a8$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $bd6886d5707a45a8$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $bd6886d5707a45a8$var$N(t, i);
        if (this.el = $bd6886d5707a45a8$var$S.createElement(f, e), $bd6886d5707a45a8$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $bd6886d5707a45a8$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($bd6886d5707a45a8$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($bd6886d5707a45a8$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $bd6886d5707a45a8$var$I : "?" === e[1] ? $bd6886d5707a45a8$var$L : "@" === e[1] ? $bd6886d5707a45a8$var$z : $bd6886d5707a45a8$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($bd6886d5707a45a8$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($bd6886d5707a45a8$var$y.test(r.tagName)) {
                    const t = r.textContent.split($bd6886d5707a45a8$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $bd6886d5707a45a8$var$s ? $bd6886d5707a45a8$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $bd6886d5707a45a8$var$c()), $bd6886d5707a45a8$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $bd6886d5707a45a8$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $bd6886d5707a45a8$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($bd6886d5707a45a8$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $bd6886d5707a45a8$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $bd6886d5707a45a8$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $bd6886d5707a45a8$var$M(t, i, s = t, e) {
    if (i === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $bd6886d5707a45a8$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $bd6886d5707a45a8$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $bd6886d5707a45a8$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $bd6886d5707a45a8$var$l).importNode(i, !0);
        $bd6886d5707a45a8$var$P.currentNode = e;
        let h = $bd6886d5707a45a8$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $bd6886d5707a45a8$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $bd6886d5707a45a8$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $bd6886d5707a45a8$var$P.nextNode(), o++);
        }
        return $bd6886d5707a45a8$var$P.currentNode = $bd6886d5707a45a8$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $bd6886d5707a45a8$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $bd6886d5707a45a8$var$M(this, t, i), $bd6886d5707a45a8$var$a(t) ? t === $bd6886d5707a45a8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && this._$AR(), this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee) : t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $bd6886d5707a45a8$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && $bd6886d5707a45a8$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($bd6886d5707a45a8$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $bd6886d5707a45a8$var$S.createElement($bd6886d5707a45a8$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $bd6886d5707a45a8$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $bd6886d5707a45a8$var$C.get(t.strings);
        return void 0 === i && $bd6886d5707a45a8$var$C.set(t.strings, i = new $bd6886d5707a45a8$var$S(t)), i;
    }
    k(t) {
        $bd6886d5707a45a8$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $bd6886d5707a45a8$var$k(this.O($bd6886d5707a45a8$var$c()), this.O($bd6886d5707a45a8$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $bd6886d5707a45a8$var$i(t).nextSibling;
            $bd6886d5707a45a8$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $bd6886d5707a45a8$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $bd6886d5707a45a8$var$M(this, t, i, 0), o = !$bd6886d5707a45a8$var$a(t) || t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $bd6886d5707a45a8$var$M(this, e[s + n], i, n), r === $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$bd6886d5707a45a8$var$a(r) || r !== this._$AH[n], r === $bd6886d5707a45a8$export$45b790e32b2810ee ? t = $bd6886d5707a45a8$export$45b790e32b2810ee : t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $bd6886d5707a45a8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $bd6886d5707a45a8$var$I extends $bd6886d5707a45a8$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $bd6886d5707a45a8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $bd6886d5707a45a8$var$L extends $bd6886d5707a45a8$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $bd6886d5707a45a8$export$45b790e32b2810ee);
    }
}
class $bd6886d5707a45a8$var$z extends $bd6886d5707a45a8$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $bd6886d5707a45a8$var$M(this, t, i, 0) ?? $bd6886d5707a45a8$export$45b790e32b2810ee) === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $bd6886d5707a45a8$export$45b790e32b2810ee && s !== $bd6886d5707a45a8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (s === $bd6886d5707a45a8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $bd6886d5707a45a8$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $bd6886d5707a45a8$var$M(this, t);
    }
}
const $bd6886d5707a45a8$export$8613d1ca9052b22e = {
    M: $bd6886d5707a45a8$var$h,
    P: $bd6886d5707a45a8$var$o,
    A: $bd6886d5707a45a8$var$n,
    C: 1,
    L: $bd6886d5707a45a8$var$N,
    R: $bd6886d5707a45a8$var$R,
    D: $bd6886d5707a45a8$var$d,
    V: $bd6886d5707a45a8$var$M,
    I: $bd6886d5707a45a8$var$k,
    H: $bd6886d5707a45a8$var$H,
    N: $bd6886d5707a45a8$var$L,
    U: $bd6886d5707a45a8$var$z,
    B: $bd6886d5707a45a8$var$I,
    F: $bd6886d5707a45a8$var$Z
}, $bd6886d5707a45a8$var$B = $bd6886d5707a45a8$var$t.litHtmlPolyfillSupport;
$bd6886d5707a45a8$var$B?.($bd6886d5707a45a8$var$S, $bd6886d5707a45a8$var$k), ($bd6886d5707a45a8$var$t.litHtmlVersions ??= []).push("3.3.2");
const $bd6886d5707a45a8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $bd6886d5707a45a8$var$k(i.insertBefore($bd6886d5707a45a8$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $baeea1393dcde116$var$s = globalThis;
class $baeea1393dcde116$export$3f2f9f5909897157 extends (0, $85ef972dd7b092e7$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $bd6886d5707a45a8$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $bd6886d5707a45a8$export$9c068ae9cc5db4e8;
    }
}
$baeea1393dcde116$export$3f2f9f5909897157._$litElement$ = !0, $baeea1393dcde116$export$3f2f9f5909897157["finalized"] = !0, $baeea1393dcde116$var$s.litElementHydrateSupport?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$var$o = $baeea1393dcde116$var$s.litElementPolyfillSupport;
$baeea1393dcde116$var$o?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($baeea1393dcde116$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b9804ca6181681c9$export$6acf61af03e62db = !1;





const $a58c6ef86f39d5a0$export$329f6ac0a85cc888 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.c-button {
  --button-background-color: var(--color-brand);
  --button-text-color: var(--color-white);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: var(--button-text-color);
  background-color: var(--button-background-color);
  border-radius: var(--border-radius-m);
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.c-button:not(.c-icon-button) {
  padding: calc(1.5 * var(--spacing-)) var(--spacing);
}

.c-button:hover {
  text-decoration: none;
}

.c-button[hidden] {
  display: none;
}

.c-button:before {
  content: "";
  z-index: -1;
  background: var(--color-black);
  opacity: 0;
  transform-origin: 50%;
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border-radius: var(--button-border-radius);
  position: absolute;
  inset: 0;
  transform: scale(.5);
}

.c-button:hover:before, .c-button:active:before {
  opacity: .15;
  transform: scale(1.2);
}

.c-button--small {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-s);
  padding-top: var(--spacing-) !important;
  padding-bottom: var(--spacing-) !important;
}

.c-button--large {
  padding-top: var(--spacing) !important;
  padding-bottom: var(--spacing) !important;
}

.c-button--support {
  --button-background-color: var(--color-brand--support);
  --button-text-color: var(--color-white);
}

.c-button--accent {
  --button-background-color: var(--color-brand--accent);
  --button-text-color: var(--color-white);
}

.c-button--grey {
  --button-background-color: var(--color-grey--light);
  --button-text-color: var(--color-grey--dark);
}

.c-button--white {
  --button-background-color: var(--color-white);
  --button-text-color: var(--color-grey--dark);
  fill: var(--color-grey--dark);
}

.c-button--white:before {
  background-color: #0000;
}

.c-button--white:hover {
  background-color: hsl(from var(--color-white) h s l / .9);
}

.c-button--ghost {
  --button-background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
}

.c-button--ghost:before {
  background-color: var(--color-white);
}

.c-button--disabled, .c-button[disabled] {
  cursor: default;
  --button-background-color: var(--color-grey--light);
}

.c-button--disabled:before, .c-button[disabled]:before {
  display: none;
}

.c-button--fullwidth {
  width: 100%;
}

.c-spec {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h3);
  font-family: var(--spec-face);
  font-style: normal;
}

@media screen and (width <= 46.9375em) {
  .c-spec {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }
}

.c-spec--amount {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

@media screen and (width <= 46.9375em) {
  .c-spec--amount {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

.c-spec__decimals {
  vertical-align: super;
  margin-left: 2px;
  font-size: .6em;
  line-height: 1;
  position: relative;
  top: .1em;
}

.c-spec--rating {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

@media screen and (width <= 46.9375em) {
  .c-spec--rating {
    font-size: var(--font-size-m);
    line-height: var(--line-height-l);
  }
}

.c-spec--rating-tab {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  line-height: 1;
}

.c-spec--rating-tab .c-spec__decimals {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  margin-left: 1px;
  top: .2em;
}

.c-star-rating {
  width: 100px;
  height: 18px;
  position: relative;
}

.c-star-rating--small {
  transform-origin: 0;
  transform: scale(.8);
}

.c-star-rating__empty {
  background: url("data:image/svg+xml,<svg width=\\"20\\" height=\\"18\\" viewBox=\\"0 0 20 18\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M9.842 14.925L3.936 18l1.128-6.512L.286 6.875l6.603-.95L9.842 0l2.953 5.925 6.603.95-4.778 4.613L15.748 18z\\" fill=\\"%23D5D5D5\\" fill-rule=\\"evenodd\\"/></svg>") 0 repeat-x;
  display: block;
  position: absolute;
  inset: 0;
}

.c-star-rating__full {
  background: url("data:image/svg+xml,<svg width=\\"20\\" height=\\"18\\" viewBox=\\"0 0 20 18\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M9.842 14.925L3.936 18l1.128-6.512L.286 6.875l6.603-.95L9.842 0l2.953 5.925 6.603.95-4.778 4.613L15.748 18z\\" fill=\\"%23FAD43A\\" fill-rule=\\"evenodd\\"/></svg>") 0 repeat-x;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.c-link {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
}

.c-link--accent {
  color: var(--color-brand--accent);
}

.c-link--accent:hover {
  color: var(--color-brand--support);
  text-decoration: none;
}

.c-link--underline {
  font-weight: normal;
  text-decoration: underline;
}

.c-link--underline:hover {
  text-decoration: none;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-border {
  border: 1px solid var(--color-grey--light);
}

.u-border--left {
  border-left: 1px solid var(--color-grey--light);
}

.u-border--right {
  border-right: 1px solid var(--color-grey--light);
}

.u-border--top {
  border-top: 1px solid var(--color-grey--light);
}

.u-border--bottom {
  border-bottom: 1px solid var(--color-grey--light);
}

.u-border-radius-none {
  border-radius: var(--border-radius-none);
}

.u-border-radius-xs {
  border-radius: var(--border-radius-xs);
}

.u-border-radius-s {
  border-radius: var(--border-radius-s);
}

.u-border-radius, .u-border-radius-m {
  border-radius: var(--border-radius-m);
}

.u-border-radius-l {
  border-radius: var(--border-radius-l);
}

.u-border-radius-xl {
  border-radius: var(--border-radius-xl);
}

.u-border-radius--left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.u-border-radius--right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.u-border-radius--top {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.u-border-radius--bottom {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.u-text-color-white {
  color: var(--color-white--base);
}

.u-bg-color-white {
  background-color: var(--color-white--base);
}

.u-text-color-white--base {
  color: var(--color-white--base);
}

.u-bg-color-white--base {
  background-color: var(--color-white--base);
}

.u-text-color-grey {
  color: var(--color-grey--base);
}

.u-bg-color-grey {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--base {
  color: var(--color-grey--base);
}

.u-bg-color-grey--base {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--dark {
  color: var(--color-grey--dark);
}

.u-bg-color-grey--dark {
  background-color: var(--color-grey--dark);
}

.u-text-color-grey--light {
  color: var(--color-grey--light);
}

.u-bg-color-grey--light {
  background-color: var(--color-grey--light);
}

.u-text-color-grey--x-light {
  color: var(--color-grey--x-light);
}

.u-bg-color-grey--x-light {
  background-color: var(--color-grey--x-light);
}

.u-text-color-black {
  color: var(--color-black--base);
}

.u-bg-color-black {
  background-color: var(--color-black--base);
}

.u-text-color-black--base {
  color: var(--color-black--base);
}

.u-bg-color-black--base {
  background-color: var(--color-black--base);
}

.u-text-color-brand {
  color: var(--color-brand--base);
}

.u-bg-color-brand {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--base {
  color: var(--color-brand--base);
}

.u-bg-color-brand--base {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--accent {
  color: var(--color-brand--accent);
}

.u-bg-color-brand--accent {
  background-color: var(--color-brand--accent);
}

.u-text-color-brand--support {
  color: var(--color-brand--support);
}

.u-bg-color-brand--support {
  background-color: var(--color-brand--support);
}

.u-text-color-status--green {
  color: var(--color-status--green);
}

.u-bg-color-status--green {
  background-color: var(--color-status--green);
}

.u-text-color-status--orange {
  color: var(--color-status--orange);
}

.u-bg-color-status--orange {
  background-color: var(--color-status--orange);
}

.u-text-color-status--yellow {
  color: var(--color-status--yellow);
}

.u-bg-color-status--yellow {
  background-color: var(--color-status--yellow);
}

.u-text-color-status--red {
  color: var(--color-status--red);
}

.u-bg-color-status--red {
  background-color: var(--color-status--red);
}

.u-text-color-status--marked {
  color: var(--color-status--marked);
}

.u-bg-color-status--marked {
  background-color: var(--color-status--marked);
}

.u-text-color-nav {
  color: var(--color-nav--base);
}

.u-bg-color-nav {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--base {
  color: var(--color-nav--base);
}

.u-bg-color-nav--base {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--hover {
  color: var(--color-nav--hover);
}

.u-bg-color-nav--hover {
  background-color: var(--color-nav--hover);
}

.u-text-color-gradient1--from {
  color: var(--color-gradient1--from);
}

.u-bg-color-gradient1--from {
  background-color: var(--color-gradient1--from);
}

.u-text-color-gradient1--to {
  color: var(--color-gradient1--to);
}

.u-bg-color-gradient1--to {
  background-color: var(--color-gradient1--to);
}

.u-text-color-gradient2--from {
  color: var(--color-gradient2--from);
}

.u-bg-color-gradient2--from {
  background-color: var(--color-gradient2--from);
}

.u-text-color-gradient2--to {
  color: var(--color-gradient2--to);
}

.u-bg-color-gradient2--to {
  background-color: var(--color-gradient2--to);
}

.u-text-color-gradient3--from {
  color: var(--color-gradient3--from);
}

.u-bg-color-gradient3--from {
  background-color: var(--color-gradient3--from);
}

.u-text-color-gradient3--to {
  color: var(--color-gradient3--to);
}

.u-bg-color-gradient3--to {
  background-color: var(--color-gradient3--to);
}

.u-gradient1 {
  background: var(--color-gradient1--from);
  background: linear-gradient(to bottom, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--inverse {
  background: var(--color-gradient1--to);
  background: linear-gradient(to bottom, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient1--ltr {
  background: var(--color-gradient1--from);
  background: linear-gradient(to right, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--rtl {
  background: var(--color-gradient1--to);
  background: linear-gradient(to right, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient2 {
  background: var(--color-gradient2--from);
  background: linear-gradient(to bottom, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--inverse {
  background: var(--color-gradient2--to);
  background: linear-gradient(to bottom, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient2--ltr {
  background: var(--color-gradient2--from);
  background: linear-gradient(to right, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--rtl {
  background: var(--color-gradient2--to);
  background: linear-gradient(to right, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient3 {
  background: var(--color-gradient3--from);
  background: linear-gradient(to bottom, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--inverse {
  background: var(--color-gradient3--to);
  background: linear-gradient(to bottom, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-gradient3--ltr {
  background: var(--color-gradient3--from);
  background: linear-gradient(to right, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--rtl {
  background: var(--color-gradient3--to);
  background: linear-gradient(to right, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}

.u-display--inline {
  display: inline !important;
}

.u-display--inline-block {
  display: inline-block !important;
}

.u-display--block {
  display: block !important;
}

.u-display--flex {
  display: flex !important;
}

.u-display--inline-flex {
  display: inline-flex !important;
}

.u-display--none {
  display: none !important;
}

@media screen and (width <= 46.9375em) {
  .u-display--inline\\(s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(s\\) {
    display: block !important;
  }

  .u-display--flex\\(s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(s\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-display--inline\\(m\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(m\\) {
    display: inline-block !important;
  }

  .u-display--block\\(m\\) {
    display: block !important;
  }

  .u-display--flex\\(m\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(m\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(m\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em), print {
  .u-display--inline\\(\\!s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!s\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!s\\) {
    display: none !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-display--inline\\(\\!l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!l\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!l\\) {
    display: none !important;
  }
}

@media screen and (width >= 75em), print {
  .u-display--inline\\(l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(l\\) {
    display: block !important;
  }

  .u-display--flex\\(l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(l\\) {
    display: none !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-display--inline\\(xl\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(xl\\) {
    display: inline-block !important;
  }

  .u-display--block\\(xl\\) {
    display: block !important;
  }

  .u-display--flex\\(xl\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(xl\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(xl\\) {
    display: none !important;
  }
}

.u-display--flow-root {
  display: flow-root !important;
}

.u-position--absolute {
  position: absolute !important;
}

.u-position--relative {
  position: relative !important;
}

.u-position--fixed {
  position: fixed !important;
}

.u-position--static {
  position: static !important;
}

.u-text-align--left {
  text-align: left !important;
}

.u-text-align--right {
  text-align: right !important;
}

.u-text-align--center {
  text-align: center !important;
}

@media screen and (width <= 46.9375em) {
  .u-text-align--left\\(s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(s\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-text-align--left\\(m\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(m\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(m\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em), print {
  .u-text-align--left\\(\\!s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!s\\) {
    text-align: center !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-text-align--left\\(\\!l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 75em), print {
  .u-text-align--left\\(l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-text-align--left\\(xl\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(xl\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(xl\\) {
    text-align: center !important;
  }
}

.u-font-weight--normal {
  font-weight: normal !important;
}

.u-font-weight--bold {
  font-weight: bold !important;
}

.u-font-style--normal {
  font-style: normal !important;
}

.u-font-style--italic {
  font-style: italic !important;
}

.u-text-decoration--underline {
  text-decoration: underline !important;
}

.u-text-decoration--line-through {
  text-decoration: line-through !important;
}

.u-text-decoration--none {
  text-decoration: none !important;
}

.u-border--none {
  border: none !important;
}

.u-border-color--inherit {
  border-color: inherit !important;
}

.u-line-height--normal {
  line-height: normal !important;
}

.u-white-space--nowrap {
  white-space: nowrap !important;
}

.u-white-space--normal {
  white-space: normal !important;
}

@media screen and (width <= 46.9375em) {
  .u-white-space--nowrap\\(s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 47em), print {
  .u-white-space--nowrap\\(\\!s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(\\!s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 75em), print {
  .u-white-space--nowrap\\(l\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(l\\) {
    white-space: normal !important;
  }
}

.u-opacity--0 {
  opacity: 0 !important;
}

.u-opacity--25 {
  opacity: .25 !important;
}

.u-opacity--50 {
  opacity: .5 !important;
}

.u-opacity--75 {
  opacity: .75 !important;
}

.u-opacity--90 {
  opacity: .9 !important;
}

.u-cursor--pointer {
  cursor: pointer !important;
}

.u-cursor--default {
  cursor: default !important;
}

.u-visibility--hidden {
  visibility: hidden !important;
}

.u-overflow--hidden {
  overflow: hidden !important;
}

.u-margin-left--auto {
  margin-left: auto !important;
}

@media screen and (width >= 47em), print {
  .u-margin-left--auto\\(\\!s\\) {
    margin-left: auto !important;
  }
}

.u-width--auto {
  width: auto !important;
}

.u-flex-wrap--nowrap {
  flex-wrap: nowrap !important;
}

.u-flex-wrap--wrap {
  flex-wrap: wrap !important;
}

@media screen and (width <= 46.9375em) {
  .u-flex-wrap--nowrap\\(s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(m\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(m\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em), print {
  .u-flex-wrap--nowrap\\(\\!s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(\\!l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 75em), print {
  .u-flex-wrap--nowrap\\(l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-flex-wrap--nowrap\\(xl\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(xl\\) {
    flex-wrap: wrap !important;
  }
}

.u-order---1 {
  order: -1 !important;
}

.u-order--1 {
  order: 1 !important;
}

@media screen and (width <= 46.9375em) {
  .u-order---1\\(s\\) {
    order: -1 !important;
  }

  .u-order--1\\(s\\) {
    order: 1 !important;
  }
}

@media screen and (width >= 47em), print {
  .u-order---1\\(\\!s\\) {
    order: -1 !important;
  }

  .u-order--1\\(\\!s\\) {
    order: 1 !important;
  }
}

.u-size-xl {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.u-size-l {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.u-size-m {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.u-size-s {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.u-size-xs {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.u-size-h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.u-size-h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.u-size-h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.u-size-h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.u-size-h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.u-size-h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

@media screen and (width <= 46.9375em) {
  .u-size-xl\\(s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-size-xl\\(m\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(m\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(m\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(m\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(m\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(m\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(m\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(m\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(m\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(m\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(m\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em), print {
  .u-size-xl\\(\\!s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width <= 74.9375em) {
  .u-size-xl\\(\\!l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 75em), print {
  .u-size-xl\\(l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 90.0625em) {
  .u-size-xl\\(xl\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(xl\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(xl\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(xl\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(xl\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(xl\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(xl\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(xl\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(xl\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(xl\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(xl\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

.u-text-decoration--dashed-underline {
  text-underline-offset: .2rem;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: from-font;
}

.u-text-decoration--none\\(hover\\):hover {
  text-decoration: none;
}

.c-rating-wrapper {
  max-width: 330px;
}

.c-rating-item--title {
  align-self: center;
}

.c-rating-item--value {
  padding: var(--spacing);
}

.c-rating-total {
  z-index: 1;
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  text-align: center;
  width: 3.8rem;
  height: 3.8rem;
  color: var(--color-white);
  line-height: 3.8rem;
  display: inline-block;
  position: relative;
}

@media screen and (width <= 46.9375em) {
  .c-rating-total {
    width: 3.3rem;
    height: 3.3rem;
    line-height: 3.3rem;
  }
}

.c-rating-total:not(.c-rating-total--transparent):after {
  content: "";
  z-index: -1;
  border-radius: var(--border-radius-xl);
  background-color: var(--color-gradient2--from);
  position: absolute;
  inset: 15%;
}

.c-rating-total__svg {
  color: var(--color-gradient2--from);
  z-index: -1;
  display: block;
  position: absolute;
  inset: 0;
}

.c-rating-total__svg svg {
  width: 100%;
  height: 100%;
  display: block;
}

.c-rating-total--tab {
  width: 3.8rem;
  height: 3.8rem;
  line-height: 3.8rem;
}

.c-rating-circle {
  border-radius: var(--border-radius-xl);
  text-align: center;
  width: 2.6rem;
  height: 2.6rem;
  color: var(--color-brand--support);
  background-color: var(--color-white);
  border: 2px solid;
  line-height: 2.4rem;
  display: inline-block;
}
`;


class $a2d1cfa884ebe0b8$var$WJProviderReviews extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.productType = "energy";
        this.pageSize = 10;
        this._reviews = [];
        this._pageNumber = 0;
        this._totalCount = 0;
        this._overallRating = 0;
        this._loading = false;
        this._error = false;
        this._hasMore = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.providerId > 0) this._loadMore();
    }
    async _loadMore() {
        if (this._loading) return;
        this._loading = true;
        this._error = false;
        const nextPage = this._pageNumber + 1;
        try {
            const url = `/api/provider/reviews?providerId=${this.providerId}&productType=${encodeURIComponent(this.productType)}&pageSize=${this.pageSize}&pageNumber=${nextPage}`;
            const res = await fetch(url, {
                headers: {
                    Accept: "application/json"
                }
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            const newReviews = Array.isArray(data?.ratings) ? data.ratings : [];
            this._reviews = [
                ...this._reviews,
                ...newReviews
            ];
            this._pageNumber = nextPage;
            this._totalCount = Number(data?.numberOfRatings) || this._reviews.length;
            this._overallRating = Number(data?.overallRating) || 0;
            this._hasMore = newReviews.length >= this.pageSize && this._reviews.length < this._totalCount;
        } catch  {
            this._error = true;
        } finally{
            this._loading = false;
        }
    }
    _formatDate(raw) {
        if (!raw) return "";
        const datePart = String(raw).split("T")[0];
        const parts = datePart.split("-");
        return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : datePart;
    }
    _renderReview(review, index) {
        const stars = Math.max(0, Math.min(5, Number(review.stars) || 0));
        const name = review.header || "Anonym";
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div class="${index === 0 ? "" : "u-border--top pt"} mb">
        <div class="u-size-s mb--">
          <strong class="mr-">${name}</strong>
          <span class="u-text-color-grey">${this._formatDate(review.lastModificationDate)}</span>
        </div>
        <div class="c-star-rating c-star-rating--small mb-">
          <span class="c-star-rating__empty"></span>
          <span class="c-star-rating__full" style="width: ${stars / 5 * 100}%"></span>
        </div>
        ${review.text ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<div class="u-size-s">${review.text}</div>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
      </div>
    `;
    }
    _renderSummary() {
        const ratingStr = (Math.round(this._overallRating * 10) / 10).toFixed(1).replace(".", ",");
        const [ratingInt, ratingDec] = ratingStr.split(",");
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div class="c-rating-wrapper mb+">
        <div class="u-bg-color-grey--x-light u-border-radius-s ph pv- mb">
          <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
            <div class="layout__item">
              <div class="u-font-weight--bold">Durchschnittliche Bewertung<span class="c-icon-info"></span></div>
              <div class="u-size-s u-font-weight--bold u-text-color-grey">${this._totalCount} Bewertungen</div>
            </div>
            <div class="layout__item u-1/4 u-text-align--center pv-">
              <span class="c-rating-total c-rating-total--tab c-spec c-spec--amount">
                ${ratingInt}<span class="c-spec__decimals">,${ratingDec}</span>
                <span class="c-rating-total__svg"
                  ><svg viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M28.195 58.036l-1.345.559a5.354 5.354 0 01-6.175-1.522l-.93-1.12a6 6 0 00-4.083-2.143l-1.45-.13a5.354 5.354 0 01-4.76-4.217l-.304-1.424a6 6 0 00-2.619-3.794l-1.224-.789A5.354 5.354 0 013.05 37.51l.393-1.401a6 6 0 00-.556-4.577l-.717-1.267a5.354 5.354 0 01.767-6.314l1-1.059a6 6 0 001.634-4.31l-.046-1.456a5.354 5.354 0 013.613-5.234l1.377-.473a6 6 0 003.451-3.057l.635-1.31a5.354 5.354 0 015.632-2.956l1.439.221a6 6 0 004.477-1.103l1.171-.865a5.354 5.354 0 016.36 0l1.171.865a6 6 0 004.477 1.103l1.44-.221a5.354 5.354 0 015.63 2.956l.636 1.31a6 6 0 003.45 3.057l1.378.473a5.354 5.354 0 013.613 5.234l-.046 1.455a6 6 0 001.635 4.311l1 1.059a5.354 5.354 0 01.766 6.314l-.717 1.267a6 6 0 00-.556 4.577l.393 1.401a5.354 5.354 0 01-2.255 5.947l-1.224.789a6 6 0 00-2.62 3.794l-.303 1.424a5.354 5.354 0 01-4.76 4.218l-1.45.13a6 6 0 00-4.083 2.142l-.93 1.12a5.354 5.354 0 01-6.175 1.522l-1.345-.56a6 6 0 00-4.61 0z"
                      fill="#61A38D"
                      class="u-svg-fill"
                    ></path>
                    <circle stroke="#F7F7F7" cx="30.5" cy="30.5" r="22" stroke-width="2"></circle></svg
                ></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    render() {
        if (!this.providerId || this.providerId <= 0) return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<p>Für diesen Anbieter sind derzeit keine Bewertungsdaten verfügbar.</p>`;
        const isInitialLoad = this._loading && this._reviews.length === 0;
        if (isInitialLoad) return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<bc-loading-icon data-inline="true"></bc-loading-icon>`;
        const hasMore = this._hasMore && this._reviews.length < this._totalCount;
        const hasSummary = this._overallRating > 0 || this._totalCount > 0;
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      ${hasSummary ? this._renderSummary() : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
      <div class="layout">
        <div class="layout__item u-19/24(l)">
          ${this._reviews.length === 0 && !this._loading && !this._error ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<p>Für diesen Anbieter sind derzeit keine Bewertungen verfügbar.</p>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)} ${this._reviews.map((r, i)=>this._renderReview(r, i))} ${this._error ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<p>Bewertungen konnten nicht geladen werden.</p>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
          ${hasMore ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
                <div class="u-text-align--center mt">
                  ${this._loading ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<bc-loading-icon data-inline="true"></bc-loading-icon>` : (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<button type="button" class="c-button c-button--support c-button--small" @click=${this._loadMore}>Weitere Bewertungen laden</button>`}
                </div>
              ` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
        </div>
      </div>
    `;
    }
}
$a2d1cfa884ebe0b8$var$WJProviderReviews.properties = {
    providerId: {
        type: Number,
        attribute: "data-provider-id"
    },
    productType: {
        type: String,
        attribute: "data-product-type"
    },
    pageSize: {
        type: Number,
        attribute: "data-page-size"
    },
    _reviews: {
        state: true
    },
    _pageNumber: {
        state: true
    },
    _totalCount: {
        state: true
    },
    _overallRating: {
        state: true
    },
    _loading: {
        state: true
    },
    _error: {
        state: true
    },
    _hasMore: {
        state: true
    }
};
$a2d1cfa884ebe0b8$var$WJProviderReviews.styles = [
    (0, $a58c6ef86f39d5a0$export$329f6ac0a85cc888)
];
const $a2d1cfa884ebe0b8$export$a2b9b921a20f690 = ()=>{
    if (!window.customElements.get("wj-provider-reviews")) window.customElements.define("wj-provider-reviews", $a2d1cfa884ebe0b8$var$WJProviderReviews);
};


(0, $a2d1cfa884ebe0b8$export$a2b9b921a20f690)();
window.addEventListener("DOMContentLoaded", ()=>{
    let inputWidget, heatingWidget, addressSolver;
    (0, $68cce00e20779c30$export$240cd81d1fa164a8)();
    (0, $31b6f657dffad9ea$export$91db7bf3cf52d2ee)();
    (0, $fc3e7aca76592be4$export$6bd9755bd64780dc)();
    (0, $7e4debd3f64ec3ac$export$f808344a2ba3e03)();
    if (inputWidget = document.querySelector(".js-input-widget")) new (0, $d720ced4833f75d1$export$76ee4dc31826cca7)(inputWidget);
    if (heatingWidget = document.querySelector(".js-heating-electricity-widget")) (0, $474553cfcd9850af$export$6c6ef03b1e085646)(heatingWidget);
    if (addressSolver = document.getElementById("address-solver")) new (0, $2c95b4ed0ac49682$export$33f74ecdf75d2956)(addressSolver);
});

})();
//# sourceMappingURL=base.js.map
